import React, { useCallback } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { CardView, hitSlop, rem, Spacer } from 'design-system';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { IconRocket } from 'design-system/icons/IconRocket';
import SectionHeader from 'design-system/SectionHeader';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useColors from 'hooks/useColors';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import links, { knownLinks } from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
import { isAndroid } from '../../../constants';
import { savePotsOnboardingState } from '../actions';
import useNavigateToNextScreenForPotsOnboarding from '../hooks/useNavigateToNextScreenForPotsOnboarding';
import useOnboarding from '../hooks/useOnboarding';
import PotProductCards from './PotProductCards';
import ProductTourIntroCard from './ProductTourIntroCard';
const bottomSpacer = HEIGHT_PLUS_PADDING + rem(16);
const NewProductTour = () => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const { navigateDeprecated } = useMainStackNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const potsAccountStatus = useAppSelector((store) => store.pots.account?.status);
    const [onboard] = useOnboarding();
    const navigateToNextScreen = useNavigateToNextScreenForPotsOnboarding();
    const handleTnc = useCallback(() => {
        if (isAndroid) {
            navigateDeprecated('Pdf', { url: knownLinks.potsTnc, buttonTitle: 'Done' });
        }
        else {
            links.openPotsTnc();
        }
    }, []);
    const handlePotProductPress = useCallback((productId) => {
        if (showUnavailableOnWeb('emma://save?tab=pots', 'Open a savings pot')) {
            return;
        }
        dispatch(setDeviceSettingsKey('hasTriedSettingsUpPots', true));
        if (potsAccountStatus === 'NOT_STARTED') {
            dispatch(savePotsOnboardingState({ productId }));
            navigateToNextScreen();
        }
    }, [navigateToNextScreen, potsAccountStatus]);
    return (<View testID="PotsProductTour">
      <ProductTourIntroCard containerStyle={paddingHorizontalStyle}/>

      <PotProductCards onPress={handlePotProductPress}/>

      <View style={paddingHorizontalStyle}>
        <SectionHeader largeVerticalMargins horizontalMargins>
          Deposits on autopilot
        </SectionHeader>
        <CardView withPadding noMarginTop>
          <Squircle color={colors.background.dark}>
            <IconRocket colorKey="brand"/>
          </Squircle>
          <Spacer h={16}/>
          <Text Text-16>Save money automatically</Text>
          <Spacer h={4}/>
          <Text TextThin-14 Secondary>
            Start saving without thinking with Emma’s automation and save the perfect amount every week
          </Text>
          <Spacer h={16}/>
          <View style={styles.row}>
            <Button square brandReversed hug title="Start autosave" onPress={onboard}/>
          </View>
        </CardView>

        <View style={styles.tncContainer}>
          <Text TextThin-14 Secondary>
            By signing up you agree to the{' '}
          </Text>
          <TouchableOpacity hitSlop={hitSlop} onPress={handleTnc}>
            <Text TextThin-14 Primary>
              T&Cs
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <Spacer h={bottomSpacer}/>
    </View>);
};
export default NewProductTour;
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    tncContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
});
